'use client'

import { PropsWithChildren } from 'react'

import { View, ViewProps } from '@/shared/config'
import { Spinner } from '@/shared/ui'

import { ResponsiveProvider } from './responsive-provider'
import { useView } from './view'

export const ResponsiveWrapper = ({
  hasInitialView,
  view: initialView,
  children,
}: PropsWithChildren<Partial<ViewProps>>) => {
  const view = useView()

  if (!hasInitialView && !view) {
    return <Spinner />
  }

  return (
    <ResponsiveProvider view={view ?? (initialView as View)}>
      {children}
    </ResponsiveProvider>
  )
}
